import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-widget-button',
  templateUrl: './button.component.html',
  imports: [
    CommonModule,
  ]
})
export class WidgetButtonComponent {

  /**
   * Button heading
   */
  heading = input('');

  /**
   * Action processing
   */
  processing = input(false);

  /**
   * Clicked event
   */
  clicked = output<void>();

  /**
   * When button is clicked
   */
  click() {
    if (!this.processing()) {
      this.clicked.emit();
    }
  }
}
